"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShelveSprinklerGenerator = void 0;
const ltentity_1 = require("../../cadplugins/cad/ltentity");
const ltpoint_1 = require("../../cadplugins/cad/ltpoint");
const ltfeature_1 = require("../../cadplugins/data/ltfeature");
const ltfields_1 = require("../../cadplugins/data/ltfields");
const riserGenerator_1 = require("./riserGenerator");
const shelveRowGroup_1 = require("./shelveRowGroup");
const Coordinate_js_1 = __importDefault(require("jsts/org/locationtech/jts/geom/Coordinate.js"));
const pipeNode_1 = require("../pipe/pipeNode");
const pipeSizeTextDrawer_1 = require("../pipe/pipeSizeTextDrawer");
const shelveDrawUtil_1 = require("./shelveDrawUtil");
const VerticalDistance = 200; //垂直间距
const HorizontalDistance = 100;
const VerticalDistanceToColumn = 600; //判断货架上方是否有柱子的距离
//喷头间的最大最小距离
const MinDistanceBetweenSprinkler = 2000;
const MaxDistanceBetweenSprinkler = 3000;
class ShelveSprinklerGenerator {
    constructor(cadMap, childPipeLayer, pipeDozzleLayer, riserLayer, pipeDiameterTextLayer, columns, sprinklerName, pipeSizeMap) {
        this._intervalNum = 2; //喷头间隔的货架数量（暂时未用上）
        this._isOddLevel = true; //是否为奇数层
        this._cadMap = cadMap;
        this._childPipeLayer = childPipeLayer;
        this._pipeDozzleLayer = pipeDozzleLayer;
        this._riserLayer = riserLayer;
        this._pipeDiameterTextLayer = pipeDiameterTextLayer;
        this._columns = columns;
        this._sprinklerName = sprinklerName;
        this._pipeSizeMap = pipeSizeMap;
    }
    generate(row_groups, isOddLevel, isMainPipeDrawing, drawscale) {
        this._isOddLevel = isOddLevel;
        //分割中间有柱子的双行货架
        for (let i = row_groups.length - 1; i >= 0; i--) {
            let group = row_groups[i];
            if (group._shelveRows.length == 1)
                continue;
            let aboveRow = group._shelveRows[0];
            let underRow = group._shelveRows[1];
            let hasColumnInMiddle = this.isLineValid(aboveRow.getMinX(), aboveRow.getMaxX(), (aboveRow.getMinY() + underRow.getMaxY()) / 2);
            if (!hasColumnInMiddle) {
                row_groups.splice(i, 1);
                row_groups.splice(i, 0, new shelveRowGroup_1.ShelveRowGroup(group._shelveRows[1]));
                row_groups.splice(i, 0, new shelveRowGroup_1.ShelveRowGroup(group._shelveRows[0]));
            }
        }
        let map = new Map();
        let shelveDrawUtil = new shelveDrawUtil_1.ShelveDrawUtil(this._riserLayer, this._cadMap);
        let currentRiserIndex = 1;
        let row_index = 0;
        for (let group of row_groups) {
            row_index++;
            let sprinklerPoints = this.computeSprinklerPoints(group, this._isOddLevel);
            let sprinklerGroups;
            if (this._isOddLevel) {
                sprinklerGroups = new riserGenerator_1.RiserGenerator().generate(sprinklerPoints, sprinklerPoints, currentRiserIndex);
            }
            else { //如果是偶数层，则计算一次奇数层的点，以得到立管位置
                sprinklerGroups = new riserGenerator_1.RiserGenerator().generate(sprinklerPoints, this.computeSprinklerPoints(group, true), currentRiserIndex);
            }
            //绘制喷头  
            for (let point of sprinklerPoints) {
                if (!isMainPipeDrawing) {
                    this.addSprinklerBlockToLayer(new ltpoint_1.LTPoint(point.x, point.y), drawscale, point.riser_name);
                }
            }
            currentRiserIndex += sprinklerGroups.length;
            for (let sprinklerGroup of sprinklerGroups) {
                if (!isMainPipeDrawing) {
                    //这里不需要groupIndex和sprinklerCount，所以随便输个-1
                    let riser_feature = shelveDrawUtil.addRiserBlockToLayer(new ltpoint_1.LTPoint(sprinklerGroup._riserPoint.x, sprinklerGroup._riserPoint.y), sprinklerGroup._riserName, -1, -1, drawscale);
                    //记录这一排立管的层号，用于后续判断是否在同一行中，如果此值无效，则简单根据坐标判断是否在同一行中
                    riser_feature._xdata.row_index = row_index;
                    this.traverseToAddLTLineToLayer(sprinklerGroup._riserNode, this._pipeSizeMap, drawscale, sprinklerGroup._riserName);
                }
            }
            map.set(group, sprinklerGroups);
        }
        return map;
    }
    computeSprinklerPoints(group, isOddLevel) {
        if (group._shelveRows.length == 1) {
            let row = group._shelveRows[0];
            let aboveValid = this.isLineValid(row.getMinX(), row.getMaxX(), row.getMaxY() + VerticalDistanceToColumn);
            return this.singleRowGenerate(row, aboveValid, isOddLevel);
        }
        else {
            return this.doubleRowGenerate(group._shelveRows, isOddLevel);
        }
    }
    addSprinklerBlockToLayer(pos, drawscale, riser_name) {
        let block = new ltentity_1.LTEntityPoint(pos);
        block.blockName = this._sprinklerName;
        block.scale(new ltpoint_1.LTPoint(drawscale, drawscale), pos);
        let feature = new ltfeature_1.LTFeature({
            geometry: block,
            layer: this._pipeDozzleLayer,
            xdata: JSON.stringify({
                source: "autoGenerate",
                riser_name: riser_name
            }),
        });
        feature.setValue(ltfields_1.FieldNames.EntityLayer, feature.layer.name);
        feature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
        feature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
        feature.setValue(ltfields_1.FieldNames.Width, 0.0);
        this._cadMap.addFeature(feature);
    }
    traverseToAddLTLineToLayer(node, pipeSizeMap, drawscale, riser_name) {
        for (let child of node._children) {
            let line = new ltentity_1.LTLine(new ltpoint_1.LTPoint(node._point.x, node._point.y), new ltpoint_1.LTPoint(child._point.x, child._point.y));
            let pipeCount = child.computeChildrenNodes();
            if (child._type == pipeNode_1.PipeNodeType.Child) { //如果child节点是喷头，则需要加上它本身
                pipeCount++;
            }
            let text = pipeSizeMap.getPipeSizeStr(pipeCount);
            let ltText = pipeSizeTextDrawer_1.PipeSizeTextDrawer.getLTText(line.getStart(), line.getEnd(), text, drawscale);
            //构建管径文字要素
            let textFeature = new ltfeature_1.LTFeature({
                geometry: ltText,
                layer: this._pipeDiameterTextLayer,
                xdata: JSON.stringify({
                    source: "autoGenerate",
                    riser_name: riser_name
                }),
            });
            textFeature.setValue(ltfields_1.FieldNames.EntityLayer, textFeature.layer.name);
            textFeature.setValue(ltfields_1.FieldNames.EntityType, "AcDbText");
            textFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            textFeature._xdata.riser_name = riser_name;
            this._cadMap.addFeature(textFeature);
            let lineFeature = new ltfeature_1.LTFeature({
                geometry: line,
                layer: this._childPipeLayer,
                xdata: JSON.stringify({
                    pipeSize: text,
                    source: "autoGenerate",
                    riser_name: riser_name
                }),
            });
            lineFeature.setValue(ltfields_1.FieldNames.EntityLayer, lineFeature.layer.name);
            lineFeature.setValue(ltfields_1.FieldNames.Color, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Linetype, ltentity_1.dwg_bylayer);
            lineFeature.setValue(ltfields_1.FieldNames.Width, 0.0);
            lineFeature.setValue(ltfields_1.FieldNames.Rotate, 0.0);
            this._cadMap.addFeature(lineFeature);
            this.traverseToAddLTLineToLayer(child, pipeSizeMap, drawscale, riser_name);
        }
    }
    singleRowGenerate(row, above, isOddLevel) {
        let y = 0;
        if (above) {
            y = row._shelves[0].getBoundingBox().max.y + VerticalDistance;
        }
        else {
            y = row._shelves[0].getBoundingBox().min.y - VerticalDistance;
        }
        let xArr = isOddLevel ? this.oddLevelHandle(row) : this.evenLevelHandle(row);
        let points = new Array();
        for (let x of xArr) {
            points.push(new Coordinate_js_1.default(x, y));
        }
        return points;
    }
    doubleRowGenerate(rows, isOddLevel) {
        //放在两行中间
        let y = (rows[0]._shelves[0].getBoundingBox().min.y + rows[1]._shelves[0].getBoundingBox().max.y) / 2;
        let xArr = isOddLevel ? this.oddLevelHandle(rows[0]) : this.evenLevelHandle(rows[0]);
        let points = new Array();
        for (let x of xArr) {
            points.push(new Coordinate_js_1.default(x, y));
        }
        return points;
    }
    //奇数层
    oddLevelHandle(row) {
        let firstX = row._shelves[0].getBoundingBox().min.x - HorizontalDistance;
        let xArr = [firstX];
        let intervalNum = this.computeIntervalNum(row, firstX);
        for (let i = intervalNum == 1 ? 0 : 1; i < row._shelves.length; i += intervalNum) {
            let shelve1 = row._shelves[i];
            let shelve2 = row._shelves[i + 1];
            if (shelve2) {
                xArr.push((shelve1.getBoundingBox().max.x + shelve2.getBoundingBox().min.x) / 2);
            }
            else { //处理末尾的情况
                xArr.push(shelve1.getBoundingBox().max.x + HorizontalDistance);
            }
        }
        return xArr;
    }
    //偶数层
    evenLevelHandle(row) {
        let xArr = new Array();
        let intervalNum = this.computeIntervalNum(row, row._shelves[0].getBoundingBox().min.x - HorizontalDistance);
        for (let i = 0; i < row._shelves.length; i += intervalNum) {
            let shelve1 = row._shelves[i];
            let shelve2 = row._shelves[i + 1];
            if (shelve2) { //仅在货架中间生成喷头，所以i==row._shelves.length-1时不生成喷头
                xArr.push((shelve1.getBoundingBox().max.x + shelve2.getBoundingBox().min.x) / 2);
            }
        }
        return xArr;
    }
    computeIntervalNum(row, firstX) {
        //通过判断货架间的距离，来决定是隔1个货架还是隔2个货架布设喷头
        //由于不明确隔3个和3个以上货架的情况怎么布设，所以这里仅作1个或者2个的判断
        let intervalNum = 2;
        if (row._shelves.length > 2) {
            //尝试按intervalNum=2来布设，判断会不会超过最大距离
            if ((row._shelves[1].getBoundingBox().max.x + row._shelves[2].getBoundingBox().min.x) / 2 - firstX > MaxDistanceBetweenSprinkler)
                intervalNum = 1;
        }
        else if (row._shelves.length == 2) {
            if (row._shelves[1].getBoundingBox().max.x + HorizontalDistance - firstX > MaxDistanceBetweenSprinkler)
                intervalNum = 1;
        }
        else { //只有一个货架的情况不作处理，只布设一个
        }
        return intervalNum;
    }
    //判断某根线是否与柱子之类的相交，相交则判断为不合法
    isLineValid(minX, maxX, y) {
        for (let column of this._columns) {
            //通过包围盒判断范围内是否有柱子
            if (y >= column._boundingBox.min.y && y <= column._boundingBox.max.y && column._boundingBox.getCenter().x >= minX && column._boundingBox.getCenter().x <= maxX) {
                return false;
            }
        }
        return true;
    }
}
exports.ShelveSprinklerGenerator = ShelveSprinklerGenerator;
